import { Trans } from "@lingui/react/macro";

import { useApiErrorMessage } from "@/shared/api";
import { Button } from "@/shared/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";

import { useDeleteAccount } from "../api/useDeleteAccount";

type DeleteAccountDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

// Подтверждение удаления аккаунта. Тексты и кнопки — по макету экрана «Профиль» → «Аккаунт»
// (`Profile.dc.html`); пока экрана нет, открывается из `UserMenu`. Диалог управляется
// снаружи: пункт меню, который его открывает, закрывается вместе с меню.
export const DeleteAccountDialog = ({ open, onOpenChange }: DeleteAccountDialogProps) => {
  const deleteAccount = useDeleteAccount();
  const errorMessage = useApiErrorMessage(deleteAccount.error);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          deleteAccount.reset();
        }
        onOpenChange(next);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete account?</Trans>
          </DialogTitle>
          <DialogDescription className="text-foreground">
            <Trans>
              All analyses, drills and progress will be deleted. Your matches in the game itself are
              not affected. This cannot be undone.
            </Trans>
          </DialogDescription>
          <p className="text-sm text-subtle">
            <Trans>Copies in database backups are kept for up to 30 days, then erased.</Trans>
          </p>
        </DialogHeader>
        {errorMessage !== null && (
          <p role="alert" className="text-sm text-bad">
            {errorMessage}
          </p>
        )}
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={deleteAccount.isPending}>
              <Trans>Cancel</Trans>
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            className="font-semibold"
            loading={deleteAccount.isPending}
            onClick={() => {
              deleteAccount.mutate({ body: { confirm: true } });
            }}
          >
            <Trans>Delete forever</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
